module.exports = __webpack_public_path__ + "assets/plus-circle.a9526520.svg";